import { render } from "./DonutChart.vue?vue&type=template&id=302ef8d5&scoped=true"
import script from "./DonutChart.vue?vue&type=script&lang=js"
export * from "./DonutChart.vue?vue&type=script&lang=js"

import "./DonutChart.vue?vue&type=style&index=0&id=302ef8d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-302ef8d5"]])

export default __exports__